<bootstrap-popup [id]="'editMemoDialog'" [title]="title">
	<form role="form" class="form-horizontal">

		<div *ngIf="mode == modes.UPDATE || mode == modes.ARCHIVE" class="form-group">
			<label for="numero" class="col-md-1 plus-half control-label">Num&eacute;ro&nbsp;*:</label>
			<div class="col-md-4 plus-half">
				<input id="numero" name="numero"
					class="form-control" 
					disabled
					[(ngModel)]="numero"
					/>
			</div>
		</div>
		
		<div class="form-group" *ngIf="mode != modes.CREATION">
			<label for="antenneName" class="col-md-1 plus-half control-label">Antenne&nbsp;*:</label>
			<div class="col-md-4 plus-half">
				<input disabled id="antenneName" name="antenneName" class="form-control" [(ngModel)]="antenneName" />
			</div>
			<label for="parcName" class="col-md-1 plus-half control-label">Parc&nbsp;:</label>
			<div class="col-md-4 plus-half">
				<input disabled id="parcName" name="parcName" class="form-control" [(ngModel)]="parcName" />
			</div>
		</div>
		
		<div *ngIf="mode === modes.CREATION;else ouvragesDefinition">
			<antenne-to-ouvrages-selector 
				[labelClass]="'col-md-1 plus-half'"
				[contextFieldClass]="'col-md-4 plus-half'"
				[ouvrageFieldClass]="'col-md-10 plus-half'"
				(antenneIdChange)="onAntenneIdChange($event)"
				[(parcId)]="parcId"
				[(ouvrageIds)]="ouvrageIds"
				>
			</antenne-to-ouvrages-selector>
		</div>
		
		<ng-template #ouvragesDefinition>
			<div class="form-group" *ngIf="mode == modes.UPDATE || mode == modes.ARCHIVE">
				<label for="ouvrageNames" class="col-md-1 plus-half control-label">Ouvrages(s)&nbsp;*:</label>
				<div class="col-md-8 plus-half ouvrage-names">
					<span>{{ ouvrageNames }}</span>
				</div>
			</div>
			<div class="form-group" *ngIf="mode == modes.CREATION_AFTER_FERMETURE_ACCES">
				<label for="ouvrageNames" class="col-md-1 plus-half control-label">Ouvrages(s)&nbsp;*:</label>
				<div class="col-md-4 plus-half">
					<multi-extended-filterable-select
						[id]="'choixOuvrages'"
						[preselectionFunction]="isOuvragePreselected"
						[list]="suggestableOuvrages"
						[labelGetter]="getOuvrageLabel"
						[reinitCommands]="reinitChoixOuvragesSubject"
						(selectedItemsChange)="onOuvrageIdsChange($event)"
						>
					</multi-extended-filterable-select>
				</div>
			</div>
		</ng-template>
		

		<div class="form-group">
			<label for="intitule" class="col-md-1 plus-half control-label">Intitul&eacute;&nbsp;*:</label>
			<div class="col-md-10 plus-half">
				<input id="intitule" name="intitule"
					class="form-control" 
					maxlength="120"
					[(ngModel)]="intitule"
					/>
			</div>
		</div>
			
 		<div class="form-group">
			<label for="categorie" class="col-md-1 plus-half control-label">Cat&eacute;gorie&nbsp;*:</label>
			<div class="col-md-4 plus-half">
				<select id="categorie" name="categorie"
					class="form-control"
					[disabled]="mode == modes.UPDATE || mode == modes.ARCHIVE"
					[(ngModel)]="selectedCategorieId"
					(change)="onSelectCategorieId()"
					>
					<option *ngFor="let categorie of categories" [ngValue]="categorie.id">{{ categorie.label }}</option>
				</select>
			</div>
			<label *ngIf="sousCategories && sousCategories.length > 0" for="souscategorie" class="col-md-1 plus-half control-label">Sous-cat&eacute;gorie&nbsp;:</label>
			<div *ngIf="sousCategories && sousCategories.length > 0" class="col-md-4 plus-half">
				<select id="souscategorie" name="souscategorie"
					class="form-control" 
					[disabled]="mode == modes.UPDATE || mode == modes.ARCHIVE"
					[(ngModel)]="selectedSousCategorieId"
					>
					<option [ngValue]="null"></option>
					<option *ngFor="let sousCategorie of sousCategories" [ngValue]="sousCategorie.id">{{ sousCategorie.label }}</option>
				</select>

			</div>
		</div>

 		<div class="form-group">
			<label for="niveau" class="col-md-1 plus-half control-label">Niveau&nbsp;*:</label>
			<div class="col-md-4 plus-half">
				<select id="niveau" name="niveau"
					class="form-control" 
					[(ngModel)]="selectedNiveauId"
					>
					<option *ngFor="let niveau of niveaux" [ngValue]="niveau.id">{{ niveau.label }}</option>
				</select>
			</div>
		</div>

		<div class="form-group">
			<label for="dateDebut" class="col-md-1 plus-half control-label">Date de d&eacute;but&nbsp;*:</label>
			<div class="col-md-4 plus-half">
				<date-input
					[id]="'dateDebut'"
					[(localDate)]="dateDebut" [disabled]="mode == modes.CREATION_AFTER_FERMETURE_ACCES"
					>
				</date-input>
			</div>
			<label for="dateDebut" class="col-md-1 plus-half control-label">Date de fin&nbsp;:</label>
			<div class="col-md-4 plus-half">
				<date-input
					[id]="'dateFin'"
					[(localDate)]="dateFin"
					>
				</date-input>
			</div>
		</div>

		<div class="form-group">
			<label for="commentaire" class="col-md-1 plus-half control-label">Commentaire&nbsp;:</label>
			<div class="col-md-10 plus-half">
				<textarea id="commentaire" name="commentaire"
					class="form-control" 
					maxlength="240"
					[(ngModel)]="commentaire"
					>
				</textarea>
			</div>
		</div>
		
		<div class="form-group">
			<div class="col-md-12 text-center">
				<button
					type="button"
					class="btn btn-default"
					style="margin-right: 6px"
					(click)="onCancelRequested()"
					>
					Annuler
				</button>
				<button *ngIf="mode === modes.CREATION || mode == modes.CREATION_AFTER_FERMETURE_ACCES"
					type="button"
					class="btn btn-success"
					(click)="onCreate()"
					>
					Cr&eacute;er
				</button>
				<button *ngIf="mode === modes.UPDATE"
					type="button"
					class="btn btn-success"
					(click)="onModify()"
					>
					Enregistrer
				</button>
				<button *ngIf="mode === modes.ARCHIVE"
					type="button"
					class="btn btn-success"
					(click)="onArchive()"
					>
					Archiver
				</button>
			</div>
		</div>
	</form>
</bootstrap-popup>